var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-10 -10 140 140",
    style: {
      enableBackground: "new 0 0 119.15 118.41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.all{vector-effect:non-scaling-stroke;fill:none;stroke:#004B91;stroke-linecap:round;stroke-miterlimit:10;stroke-width:6}\n\t.st0{fill:#FFFFFF;stroke:none}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "all st0",
    cx: 58.93,
    cy: 59.1,
    r: 56.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "all st1 icon_status",
    d: "M114.86,54.94c0.11,1.41,0.16,2.83,0.16,4.26c0,31.04-25.08,56.2-56.01,56.2S3,90.25,3,59.2S28.08,3,59.01,3 c7.57,0,14.78,1.51,21.37,4.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "all st1 icon_status",
    points: "38.5,49.37 58.8,69.67 116.15,16.09 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.79ccedb73c6990a6862f0692a11a7977.svg";
export { ForwardRef as ReactComponent };